<template>
    <div>
        <modal-form modal-id="expand-ip" animation="fadeInRight">
            <div slot="title">Ip Information</div>
            <div slot="form" v-if="ipInfo.data">
                <div class="row m-t-xs">
                    <div class="col-lg-2"><strong>IP</strong></div>
                    <div class="col-lg-10" :class="ipInfo.data.ipData.status === 'PENDING_CANCELLATION' ? 'cancelled' : ''">
                        <span>{{ ipInfo.ip }}</span>
                    </div>
                </div>
                <div class="row m-t-xs">
                    <div class="col-lg-2"><strong>Location</strong></div>
                    <div class="col-lg-10">
                        <span>{{ ipInfo.data ? ipInfo.data.ipData.data.city : '/' }}, {{ ipInfo.data ? ipInfo.data.ipData.data.country : '/' }}</span>
                    </div>
                </div>
                <div class="row m-t-xs">
                    <div class="col-lg-2"><strong>Slots</strong></div>
                    <div class="col-lg-10">
                        <ul style="width:30%;">
                            <li>Total Slots: <span class="pull-right"><strong>{{ ipInfo.slots }}</strong></span></li>
                            <li>Used Slots: <span class="pull-right"><strong>{{ ipInfo.used }}</strong></span></li>
                            <li>Free Slots: <span class="pull-right"><strong>{{ ipInfo.freeSlots }}</strong></span></li>
                        </ul>
                    </div>
                </div>
                <div class="row m-t-xs">
                    <div class="col-lg-2"><strong>Clients</strong></div>
                    <div class="col-lg-10" v-if="ipInfo.clients && ipInfo.clients.length">
                        <ul>
                            <li v-for="client in ipInfo.clients" :key="client.id">
                                {{ client.name }}
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <span>No clients assigned to this IP yet</span>
                    </div>
                </div>
                <div class="row m-t-xs">
                    <div class="col-lg-2"><strong>PBNs</strong></div>
                    <div class="col-lg-10" v-if="ipInfo.pbns && ipInfo.pbns.length">
                        <ul>
                            <li v-for="pbn in ipInfo.pbns" :key="pbn.id">
                                {{ pbn.domain }} ({{  pbn.client ? pbn.client.name : '/' }})
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <span>No Pbns assigned to this IP yet</span>
                    </div>
                </div>
              <div class="row m-t-xs" v-if="ipInfo.data">
                <div class="col-lg-2">
                  <strong>Cost:</strong><br>
                  <strong>Per Site:</strong>
                </div>
                <div class="col-lg-10">
                  {{ ipInfo.data.ipData.monthlyCost.amount }} {{ ipInfo.data.ipData.monthlyCost.currency }}<br>
                  {{ ipInfo.data.ipData.siteCost }} {{ ipInfo.data.ipData.monthlyCost.currency }}
                </div>
              </div>
              <div class="row m-t-xs" v-if="ipInfo.data && ipInfo.data.ipData.status !== 'PENDING_CANCELLATION'">
                <div class="col-lg-2">
                  <strong>Billing:</strong><br>
                  <strong>Next:</strong>
                </div>
                <div class="col-lg-10">
                  {{ ipInfo.data.ipData.cycle }}<br>
                  {{ ipInfo.data.ipData.nextInvoiceString | aTime }}
                </div>
              </div>
            </div>
            <div slot="footer">
                <button class="btn btn-primary" @click="hideModal()">Close</button>
            </div>
        </modal-form>
        <div class="col-lg-6">
            <table class="table table-hover">
                <thead>
                    <tr>
                      <th>List of unused IPs</th>
                      <th>Location</th>
                      <th>Slots</th>
                      <th>Cost (€)</th>
                      <th>Next Billing</th>
                      <th></th>
                    </tr>
                </thead>
                <tbody v-if="emptyIps.length">
                    <tr v-for="ip in emptyIps" :key="'empty-' + ip.id">
                      <td :class="ip.data.ipData.status === 'PENDING_CANCELLATION' ? 'cancelled' : ''">{{ ip.ip }}</td>
                      <td>{{ ip.data.ipData.data.city }}, {{ ip.data.ipData.data.country }}</td>
                      <td>{{ ip.slots }}</td>
                      <td>{{ ip.data.ipData.siteCost }}</td>
                      <td>{{ ip.data.ipData.nextInvoiceString | aTime('from') }}</td>
                      <td>
                        <a data-toggle="modal" data-target="#expand-ip" @click="ipInfo = ip">
                          <i class="fa-solid fa-up-right-and-down-left-from-center" v-tooltip="'Expand IP info'"></i>
                        </a>
                        <a
                          v-if="ip.data.ipData.status === 'ACTIVE'"
                          v-tooltip="'Cancel IP'" @click="cancelIp(ip.data.ipData.id)"><i class="fa fa-trash red"></i></a>
                      </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                       <td>
                            <i class="fa-solid fa-circle-check green fa-lg"></i>
                            There are no unused IPs!
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-lg-6">
            <table class="table table-hover">
                <thead>
                    <tr>
                      <th>List of IPs with unused slots</th>
                      <th>Location</th>
                      <th>Slots</th>
                      <th>Free</th>
                      <th>Clients</th>
                      <th v-tooltip="'Cost Per Site'">CPS</th>
                      <th></th>
                    </tr>
                </thead>
                <tbody v-if="freeIps.length">
                    <tr v-for="ip in freeIps" :key="ip.id">
                        <td><a data-toggle="modal" data-target="#expand-ip" @click="ipInfo = ip" :class="ip.data.ipData.status === 'PENDING_CANCELLATION' ? 'cancelled' : ''">{{ ip.ip }}</a></td>
                        <td>{{ ip.data.ipData.data.city }}, {{ ip.data.ipData.data.country }}</td>
                        <td>{{ ip.used }}/{{ ip.slots }}</td>
                        <td>{{ ip.freeSlots }}</td>
                      <td v-tooltip="ip.clients.map(c => c.name).join(', ')">{{ ip.clients.length > 0 ? ip.clients.map(c => c.name).join(', ').length > 17 ? ip.clients.map(c => c.name).join(', ').slice(0,17).concat('...') : ip.clients.map(c => c.name).join(', ') : '/' }}</td>
                      <td>{{ ip.data.ipData.siteCost }}</td>
                      <td>
                        <a data-toggle="modal" data-target="#expand-ip" @click="ipInfo = ip">
                          <i class="fa-solid fa-up-right-and-down-left-from-center" v-tooltip="'Expand IP info'"></i>
                        </a>
                      </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                       <td>
                            <i class="fa-solid fa-circle-check green fa-lg"></i>
                            There are no IPs with unused slots!
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import Form from '../../../Helpers/Modal/Form.vue'
import axios from 'axios'

export default {
  data () {
    return {
      activeComponent: 'dashboardTab',
      ipInfo: {},
      emptyIps: [],
      freeIps: []
    }
  },
  components: {
    modalForm: Form
  },
  mounted () {
    this.fetchIps()
  },
  computed: {
  },
  methods: {
    hideModal () {
      this.ipInfo = {}
      $('#expand-ip').modal('hide')
    },
    async fetchIps () {
      let empty = await axios.get(`/integrations/priority-prospect?show=empty`)
      this.emptyIps = empty.data
      let free = await axios.get(`/integrations/priority-prospect?show=free`)
      this.freeIps = free.data
    },
    async cancelIp (id) {
      if (!confirm('Are you sure you want to cancel this IP?')) {
        return
      }
      await axios.delete(`/integrations/priority-prospect/ip/${id}`)
      this.$toastr.success('IP Cancelled', 'It will be automatically removed after it expires')
      await this.fetchIps()
    }
  }
}
</script>
<style scoped>
.cancelled {
  text-decoration: line-through;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/IPOverview/IPTabs/IPDashboard.vue